import { useState } from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@mui/material";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

const TmsOtpLogsModal = ({ open, handleClose, hospitalLogs }) => {
  const [isLoading] = useState(false); // If you need loading, implement it properly

  const getDate = (dateString) => {
    if (!dateString) return "--";
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch (e) {
      return "--";
    }
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '1200px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '16px',
    p: 4,
    maxHeight: '90vh',
    overflowY: 'auto'
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="otp-logs-modal"
      aria-describedby="otp-logs-details"
    >
      <Box sx={modalStyle}>
        <div className="tms-otp-modal">
          <h2 className="text-2xl font-bold mb-4">OTP Log Details</h2>

          {isLoading ? (
            <div className="flex justify-center">
              <CircularProgress />
            </div>
          ) : (
            <div>
              <div className={`grid grid-cols-5 text-[#797979] text-[18px] px-8`}>
                <div>
                  <div className="text-[#191919] font-semibold mb-4">Log Time</div>
                </div>
                {/* <div>
                  <div className="text-[#191919] font-semibold mb-4">Hospital Name</div>
                </div> */}
                <div>
                  <div className="text-[#191919] font-semibold mb-4">TMS Mobile</div>
                </div>
                <div>
                  <div className="text-[#191919] font-semibold mb-4">Mobile Version</div>
                </div>
                <div>
                  <div className="text-[#191919] font-semibold mb-4">Error Code</div>
                </div>
                <div>
                  <div className="text-[#191919] font-semibold mb-4">Reason</div>
                </div>
              </div>

              {hospitalLogs && hospitalLogs?.length > 0 ? (
                hospitalLogs.map((otp, idx) => (
                  <div
                    key={idx}
                    className={`py-6 px-8 rounded-[16px] ${
                      idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                    }`}
                  >
                    <div className={`grid grid-cols-5 text-[#797979] text-[18px]`}>
                      <div>{getDate(otp?.createdAt)}</div>
                      {/* <div>{otp?.digitalmedicouser?.hospital?.name || "--"}</div> */}
                      <div>{otp?.mobileNo || "--"}</div>
                      <div>{otp?.mobileVersion || "--"}</div>
                      <div>{otp?.errorCode || "--"}</div>
                      <div>{otp?.reason || "--"}</div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-xl flex items-center justify-center mt-5 font-semibold h-[300px]">
                  No OTP Logs Found
                </div>
              )}
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
};

TmsOtpLogsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  hospitalLogs: PropTypes.array.isRequired,
};

export default TmsOtpLogsModal;